import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import Icon from "./Icon";

export default function MobileAppBar({ handleMobileDrawerOpen, mobileOpen }) {
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background: "black",
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            size="large"
            aria-label="open drawer"
            onClick={handleMobileDrawerOpen}
            edge="start"
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1 }} />
          <Link
            to="/"
            style={{
              textDecoration: "none",
              color: "white",
            }}
          >
            <Icon />
          </Link>
          <Box sx={{ flexGrow: 1 }} />
        </Toolbar>
      </AppBar>
    </>
  );
}
